const KALIT = "skud.employees.columns";

/**
 * Jadval ustunlari — «Ustunlar» menyusidagi tartibda.
 *
 * ⚠️ **«Telefon» standart bo'yicha KO'RINADI**, garchi kanvasda bo'lmasa
 * ham: `EmployeeListItemSchema` uni ATAYLAB qo'shgan («bu xodim qaysi raqam
 * bilan kiradi» savoli aks holda javobsiz qolardi). Uni jimgina o'chirish
 * yopilgan savolni qayta ochardi; foydalanuvchi menyudan o'chira oladi.
 *
 * ⚠️ `crypto.randomUUID` ISHLATILMAYDI — staging TLS'siz LAN IP'da
 * `undefined` (`secure-context.test.ts` qorovuli). Ustun kalitlari —
 * qattiq yozilgan satrlar.
 */
export const COLUMN_KEYS = [
	"fullName",
	"phone",
	"positionId",
	"departmentId",
	"zone",
	"attendance30",
	"avgLate",
	"hrStatus",
	"risk",
] as const;

export type ColumnKey = (typeof COLUMN_KEYS)[number];

/** ⚠️ O'chirib bo'lmaydigan ustunlar — menyuda `disabled` va doim `Set` da. */
export const LOCKED_COLUMNS: ColumnKey[] = ["fullName", "hrStatus"];

/**
 * ⚠️⚠️ `localStorage` HAR DOIM `try/catch` ichida — o'qish emas, TA'RIFGA
 * TEGISH `SecurityError` tashlaydi (brauzer sayt ma'lumotlarini
 * bloklaganda). Qorovulsiz butun sahifa oq ekranga aylanardi. Naqsh va
 * sabab: `shared/hooks/useRecentlyViewed.ts`.
 *
 * ⚠️ Buzuq saqlangan qiymat ham yiqitmaydi — `JSON.parse` natijasi massiv
 * emas bo'lsa standartga qaytiladi.
 *
 * ⚠️ Afzallik SERVERGA yozilmaydi: u qurilmaga xos qulaylik, audit izi emas.
 */
export function readColumnPrefs(): Set<ColumnKey> {
	try {
		const xom = window.localStorage.getItem(KALIT);

		if (!xom) {
			return new Set(COLUMN_KEYS);
		}

		const parsed: unknown = JSON.parse(xom);

		if (!Array.isArray(parsed)) {
			return new Set(COLUMN_KEYS);
		}

		// ⚠️ Noma'lum kalit TASHLANADI (eski versiyadan qolgan qiymat), lekin
		// majburiy ustunlar har doim qaytariladi.
		const known = parsed.filter((key): key is ColumnKey =>
			(COLUMN_KEYS as readonly string[]).includes(key as string)
		);

		return new Set<ColumnKey>([...known, ...LOCKED_COLUMNS]);
	} catch {
		return new Set(COLUMN_KEYS);
	}
}

export function writeColumnPrefs(keys: Set<ColumnKey>): void {
	try {
		window.localStorage.setItem(KALIT, JSON.stringify([...keys]));
	} catch {
		// Saqlash imkoni yo'q — afzallik shu sessiyada yashaydi.
	}
}
